module.exports = __webpack_public_path__ + "media/images/flags/16/Kiribati-0ece8177ae7d98e4964a960a6461cb2c.png";